import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { InformeTasasItemResultsViewModel, FilterSearchingInformeTasasViewModel } from '../informes.types';
import { InformesService } from '../informes.service';
import { DatePipe } from '@angular/common';
import { Tc } from '../../../core/_infrastructure/types/common';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { Table } from 'primeng/table';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-informe-busqueda',
    templateUrl: './informe-busqueda.component.html',
})
export class InformeBusquedaComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    resultInformeTasas: InformeTasasItemResultsViewModel;

    listProvincias: Tc[];
    listPuntosInspeccion: Tc[];

    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];

    OrderBy: string = 'IdPuntoInspeccion';
    OrderAsc: number = 0;

    //campos para guardar las descripciones de los combos. Se pasarán al modelo al realizar la búsqueda
    IdProvinciaDescripcion: string = '';
    IdPuntoInspeccionDescripcion: string = '';

    isCollapsed = false;

    visibilitySpinner = false;
    loadingPIFs = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private informesService: InformesService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultInformeTasas = new InformeTasasItemResultsViewModel();
    }

    ngOnInit() {
        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.cols = [
            { field: 'Link', header: '' },
            //{ field: 'IdTasa', header: 'IdSolicitud', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Provincia', header: 'Provincia' },
            { field: 'PuntoInspeccion', header: 'Punto Inspección' },
            { field: 'FechaSolicitud', header: 'Fecha Solicitud' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'TotalTasas', header: 'Importe Tasa (‚¬)' },
            { field: 'NumeroLiquidacion', header: 'Nº Liquidación' },
            { field: 'FechaLiquidacion', header: 'Fecha Liquidación' },
        ];

        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        this.form = this.fb.group({
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            IdProvincia: null,
            IdPuntoInspeccion: null,
        });
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    CreateModel() {
        let model: FilterSearchingInformeTasasViewModel = new FilterSearchingInformeTasasViewModel();

        model.FechaDesde = this.form.value.FechaDesde;
        model.FechaHasta = this.form.value.FechaHasta != null ? this.getFechaHasta() : this.form.value.FechaHasta;
        model.IdProvincia = this.form.value.IdProvincia;
        model.IdProvinciaDescripcion = this.IdProvinciaDescripcion;
        model.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        model.IdPuntoInspeccionDescripcion = this.IdPuntoInspeccionDescripcion;

        return model;
    }

    getFechaHasta(): Date {
        (this.form.value.FechaHasta as Date).setHours(23);
        (this.form.value.FechaHasta as Date).setMinutes(59);
        (this.form.value.FechaHasta as Date).setSeconds(59);

        return this.form.value.FechaHasta as Date;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy == '' ? this.OrderBy : orderBy);
        params = params.append('idProvincia', this.form.value.IdProvincia);
        params = params.append('idPuntoInspeccion', this.form.value.IdPuntoInspeccion);
        params = params.append('FechaDesde', this.form.value.FechaDesde != null ? this.form.value.FechaDesde.toDateString() : '');
        params = params.append('FechaHasta', this.form.value.FechaHasta != null ? this.getFechaHasta().toLocaleString('es-ES', { hour12: false }) : '');

        //se guarda para que en Excel salga ordenado igual
        this.OrderBy = orderBy == '' ? this.OrderBy : orderBy; //actualizamos por si el usuario decidió ordenar por una columna del grid. Se guarda para el Excel
        this.OrderAsc = asc;

        this.informesService.getInformeTasasPagedByFilter(params).subscribe(result => {
            this.resultInformeTasas = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onSelectPuntoInspeccion(event: Tc) {
        this.IdPuntoInspeccionDescripcion = '';

        //detectar si ha pulsado el botón de eliminar selección del combo
        if (event != undefined) {
            this.IdPuntoInspeccionDescripcion = event.Descripcion;
        } else {
            return;
        }
    }

    onSelectProvincia(event: Tc) {
        this.IdProvinciaDescripcion = '';
        //limpiar descripciones de campos dependientes
        this.IdPuntoInspeccionDescripcion = '';

        //limpiar listas que alimentan los combos dependientes
        this.listPuntosInspeccion = [];

        //detectar si ha pulsado el botón de eliminar selección del combo
        if (event != undefined) {
            this.IdProvinciaDescripcion = event.Descripcion;

            //cargar combos dependientes
            this.loadingPIFs = true;
            this.globalService.getPuntoInspeccionByProvincia(event.Id).subscribe(res => {
                this.loadingPIFs = false;
                this.listPuntosInspeccion = res;
            });
        }

        //resetear selección de combos dependientes de éste
        this.form.patchValue({
            IdPuntoInspeccion: null,
        });
    }

    onCleanButton() {
        this.form.setValue({
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            IdProvincia: null,
            IdPuntoInspeccion: null,
        });

        this.OrderBy = 'IdPuntoInspeccion';

        this.listPuntosInspeccion = [];

        //se limpian los campos que guardan las descripciones que se asignan al modelo para viajar a servidor
        this.IdProvinciaDescripcion = '';
        this.IdPuntoInspeccionDescripcion = '';
        this.isCollapsed = false;
        this.searchingButton = false;
        this.resultInformeTasas = new InformeTasasItemResultsViewModel();
    }

    onBack() {
        this.router.navigate(['/global/informes']);
    }

    onExportExcel() {
        let model: FilterSearchingInformeTasasViewModel = this.CreateModel();

        //se cogen los criterios que haya
        model.OrderBy = this.OrderBy;
        model.Asc = this.OrderAsc;

        this.visibilitySpinner = true;
        this.informesService.exportInformeTasas(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultInformeTasas?.ResultList ? this.resultInformeTasas?.ResultList?.length > 0 : false;
    }
}
